import isNil from 'lodash/isNil';
import { INFT } from 'src/gql/types';

export const getMaxAvailableAmountForSale = (currentNFT: INFT | null): number => {
  if (isNil(currentNFT)) return 0;
  return Number(currentNFT?.totalAmount) - Number(currentNFT?.onSaleAmount);
};
